export const GET_STATUS = 'TWO_FACTOR/GET_STATUS'
export const SUBMIT = 'TWO_FACTOR/SUBMIT'
